import s from './styles.module.css'
import Section from '../index'
import CardList from '../card-list'
import Card from '../card'
import { Post } from '../../../../types/blog-types'
import { Dispatch } from 'react'
import * as R from 'ramda'
import { Button } from '../../../design-system'

const countCategory = (category, count = 0) => {
  if (category?.fields?.parent) {
    count += count + 1
    return countCategory(category.fields.parent, count)
  }
  return count
}
const getMostSpecificCategory = post => {
  if (!post.fields.categories) return []
  let greatest = []
  let greatestCount = 0
  post.fields.categories.forEach(category => {
    const count = countCategory(category)
    if (count > greatestCount) {
      greatest = [category]
      greatestCount = count
    } else if (count === greatestCount) {
      greatest.push(category)
    }
  })
  return greatest
}

const PostGrid = ({
  title,
  posts,
  limit,
  setLimit,
}: {
  title: string
  limit: number
  posts: [Post]
  setLimit: Dispatch<number>
}) => {
  return (
    <div className={s.sectionWithPadding}>
      <Section title={title}>
        <CardList type="vertical" className={s.featuredList}>
          {R.take(
            limit,
            R.addIndex(R.map)((post, i) => {
              return (
                <Card
                  key={`feature-${post.sys.id}`}
                  type="flat"
                  isFeature={i === 0}
                  categories={getMostSpecificCategory(post)}
                  post={post}
                />
              )
            }, posts)
          )}
        </CardList>
        {posts.length > limit && (
          <div className={s.loadMoreWrapper}>
            <Button
              variant="darkHallow"
              style={{ border: 'none', borderStyle: 'none' }}
              onClick={() => setLimit(limit + 4)}>
              Load More
            </Button>
          </div>
        )}
      </Section>
    </div>
  )
}

export default PostGrid
